import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [ 
        //首页
        {
            path: '/',
            name:'/',
            component: () => import("@/pages/Home/HomeIndex.vue"),
        },
        // 海宁乡厨
        {
            path: '/kitchen',
            name:'/kitchen',
            component: () => import("@/pages/Home/kitchenIndex.vue")
        },
        // 海宁详情
        {
            path: '/kitchenDetail',
            name:'/kitchenDetail',
            component: () => import("@/pages/Home/kitchenDetail.vue")
        },
        // 农村家宴中心
        {
            path: '/feast',
            name:'/feast',
            component: () => import("@/pages/Home/feastIndex.vue")
        },
        // 农村家宴中心详情
        {
            path: '/feastDetail',
            name:'/feastDetail',
            component: () => import("@/pages/Home/feastDetail.vue")
        },
        // 聚餐备案信息列表
        {
            path: '/mete',
            name:'/mete',
            component: () => import("@/pages/Home/meteIndex.vue")
        },
        // 处罚详情
        {
            path: '/punish',
            name:'/punish',
            component: () => import("@/pages/Home/punishDetails.vue")
        },
        // 聚餐备案信息详情
        {
            path: '/dine',
            name:'/dine',
            component: () => import("@/pages/Home/dineDetail.vue")
        },
        // 量化等级评定列表
        {
            path: '/grade',
            name:'/grade',
            component: () => import("@/pages/Home/gradeIndex.vue")
        },
        // 量化等级评定列表详情
        {
            path: '/gradeDetail',
            name:'/gradeDetail',
            component: () => import("@/pages/Home/gradeDetail.vue")
        },
    ]
})



export default router;
